import API from 'services/API';
import { moment } from 'utils';

export default function getUserInfo() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/info/v2',
    mapper: function (data) {
      return {
        inn: data.inn,
        name: data.name,
        ...data,
        dataLastUpdate: data.dataLastUpdate ? moment.fromServerDatetime(data.dataLastUpdate) : null,
        hasData: true,
        hasActualData: true,
        needEmail: !data.email,
        isConvertation: data.convertationStatus === 1,
      };
    },
  });
}
